import { render } from "./BpmnHelp.vue?vue&type=template&id=a23e87e8&scoped=true"
const script = {}

import "./BpmnHelp.vue?vue&type=style&index=0&id=a23e87e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23e87e8"]])

export default __exports__